__turbopack_context__.v({
  "container": "yIA20q_container",
  "count--1": "yIA20q_count--1",
  "count--2": "yIA20q_count--2",
  "inner": "yIA20q_inner",
  "item": "yIA20q_item",
  "size--sm": "yIA20q_size--sm",
});
